import { useEffect, useRef, useState } from "react";
import "./FloatingField.css";

const FloatingField = ({ children, value, label, id, inputType = "text", isPassword = false, onToggle, toggleIcon }) => {
    const containerRef = useRef(null);
    const [filled, setFilled] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);

    useEffect(() => {
        // Considera lleno si tiene algún valor
        if (inputType === "date") {
            setFilled(value && value.toString().length > 0);
        } else {
            setFilled(value !== "");
        }
    }, [value, inputType]);

    // 🧠 Clonar el input y agregarle los handlers automáticamente
    const enhancedChild = children && children.type === "input"
        ? {
            ...children,
            props: {
                ...children.props,
                onFocus: (e) => {
                    handleFocus();
                    if (children.props.onFocus) children.props.onFocus(e);
                },
                onBlur: (e) => {
                    handleBlur();
                    if (children.props.onBlur) children.props.onBlur(e);
                },
            },
        }
        : children;

    return (
        <div
            className={`floating-field ${filled ? "filled" : ""} ${isFocused ? "focused" : ""}`}
            ref={containerRef}
        >
            <div className="input-wrapper">
                {enhancedChild}
                {isPassword && (
                    <button type="button" className="password-toggle" onClick={onToggle}>
                        {toggleIcon}
                    </button>
                )}
            </div>
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

export default FloatingField;
